import { Slot } from '@radix-ui/react-slot'

import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

type SubtitleProps = React.ComponentPropsWithRef<'h3'> &
  VariantProps<typeof subtitleVariants> & {
    asChild?: boolean
  }

const subtitleVariants = tv({
  base: 'font-sans text-fourpulse/small tracking-normal',
  variants: {
    variant: {
      'default-bold': 'no-underline',
      'underline-bold': 'underline',
      'default-regular': 'font-regular no-underline',
    },
  },
  compoundVariants: [
    {
      variant: ['default-bold', 'underline-bold'],
      class: 'font-bold',
    },
  ],
  defaultVariants: {
    variant: 'default-bold',
  },
})

function Subtitle({ variant, asChild, ...props }: SubtitleProps) {
  const Comp = asChild ? Slot : 'h3'

  return (
    <Comp
      {...props}
      className={cn(
        subtitleVariants({
          variant,
        })
      )}
    />
  )
}

export { Subtitle }
export type { SubtitleProps }
